export default __webpack_public_path__ + "static/media/enter_data_manually.19b6be58.svg";